import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { CoreActions } from '@next/core-lib';
import { RootState } from '@next/core-lib/app';
import { LocaleService } from '@next/core-lib/i18n';
import { Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { switchMap, skipWhile } from 'rxjs/operators';
import { isTemplateIdValid, isTemplatesSet } from 'src/app/store/selectors';

@Injectable()
export class TemplateFoundGuard {
  private readonly store = inject<Store<RootState>>(Store);
  private readonly locale = inject(LocaleService);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const id = +route.paramMap.get('id');
    return this.store.pipe(
      select(isTemplatesSet),
      skipWhile((isSet) => !isSet),
      switchMap(() =>
        this.store.pipe(
          select(isTemplateIdValid, id),
          switchMap((result) => {
            if (!result) {
              this.store.dispatch(
                CoreActions.fatalError({
                  message: this.locale.translate('templateNotFound'),
                  code: 404,
                }),
              );
            }

            return of(result);
          }),
        ),
      ),
    );
  }
}
